"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DDSFieldIds = void 0;
exports.DDSFieldIds = {
    ANCHOR_ASSEMBLY: 'ddsAnchorAssembly',
    FRAMING_TYPE: 'ddsFramingType',
    WIRE_UNIT: 'ddsWireUnit',
    JOINT_USE_CABLE: {
        FORM: 'ddsJointUseCable',
        MID_SPAN_HEIGHT: 'ddsJointUseCableMidSpanHeight',
        NAME: 'ddsJointUseCableName',
        OWNER: 'ddsJointUseCableOwner',
        ATTACHMENT_HEIGHT: 'ddsJointUseCableAttachmentHeight',
        MESSENGER: 'ddsJointUseCableMessenger',
    },
};
//# sourceMappingURL=FieldID.js.map